(function () {
    'use strict';
    var app = angular.module('app.directives');

    app.directive('restrictPlate', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.bind('keypress', function(event) {
                        var regex = /^[a-zA-Z0-9-]*$/;
                        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
                        if (!regex.test(key)) {
                            event.preventDefault();
                            return false;
                        }
                    });
                });
            }
        };
    }]);

})();